module.exports = __webpack_public_path__ + "static/media/thumbnail-uzemi-epulet-gepi-bontasa.18bff759.jpg";